<template lang="html">
  <b-field>
    <template slot="label">
      Description
      <b-tooltip
        position="is-right"
        multilined
        size="is-small"
        type="is-dark"
        label="Short description to summarize the content"
      >
        <b-icon type="is-gray" size="is-small" icon="help-circle-outline"></b-icon>
      </b-tooltip>
    </template>
    <b-input
      maxlength="1000"
      type="textarea"
      v-model="localDescription"
      @input="updateDescription"
    />
  </b-field>
</template>

<script>
export default {
  props: ['description'],
  data () {
    return {
      localDescription: null
    }
  },
  created () {
    this.localDescription = this.description
  },
  methods: {
    updateDescription (value) {
      this.$emit('updateDescription', value)
    }
  }
}
</script>

<style lang="scss" scoped></style>
